import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptBrick1x1x1} from './brick1x1x1.script.js';

/**
 * Creates 1x1x1 brick gameobjects.
 * @param {string} $model The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectbrick1x1x1($model) {

    const brick1x1x1 = new HYPERCUBEJS.Node('brick1x1x1');
    const meshbrick1x1x1 = new HYPERCUBEJS.MeshBox('meshbrick1x1x1', [1, 1, 1]);

    const gray = 0.8 + 0.2 * Math.random();

    const color = new HYPERCUBEJS.MaterialColor('plop', {

        // 'color': [Math.random(), Math.random(), Math.random()]
        // 'color': [Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5]
        // 'color': [1.0, 1.0, 1.0]
        'color': [gray, gray, gray]
    });

    meshbrick1x1x1.setmaterial(color);

    // meshbrick1x1x1.setmaterial($material);
    brick1x1x1.addmesh(meshbrick1x1x1);
    brick1x1x1.setscript(new ScriptBrick1x1x1($model));

    brick1x1x1.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-0.5, -0.5, -0.5],
        'max': [0.5, 0.5, 0.5]
    });

    return brick1x1x1;
}

export {

    gameobjectbrick1x1x1
};

export default gameobjectbrick1x1x1;
